import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CampoPersonalizadoService {

  constructor(private http: HttpClient) {}

  consultarCampoPersonalizadoComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipoAplicacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoAplicacao', tipoAplicacao);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CampoPersonalizado/ListaPag',
      {
        params: parametros
      });
  }

  consultarTodosCampoPersonalizado() {
    return this.http.get<any>(globals.apiUrl + '/api/CampoPersonalizado/Lista');
  }

  salvar(campoPersonalizado) {
    return this.http.post(globals.apiUrl + '/api/CampoPersonalizado/Salvar', campoPersonalizado);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CampoPersonalizado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  verificaSePodeExcluirItem(id) {
    return this.http.get<any>(globals.apiUrl + '/api/CampoPersonalizado/PodeExcluirItem',
      { params: new HttpParams().set('idItem', id) });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/CampoPersonalizado/Buscar',
      { params: new HttpParams().set('id', id) });
  }
}
